module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAACCAYAAAA3t6CmAAAAAXNSR0IArs4c6QAAAN9JREFUKFN1krkOhDAMRHHCESoq/pi/RVtSgBRnNRYTmSxbIDs+JvEzsm3bJ4SQRURFJHsfMZzxdV338O9ai8FnrbNVM8b40+81+77Pqlr1W61SikIDPfRxps+38x2w0ESe9s5ZbBiGqjWOo8Wg7TXhX9el8zzn8zxNB32oVdXMvpRSPo5DYZlblgXz2szeCmF7mBy2BezBe4AN7Ad41CH/poUYhuCDuGje0y7uH2z0hxBsIRiYPwKhwzIeY7Q8AfMunKdpqgvkIgGWC/OwkQfwBrb9NIC977uu68rZbP4vrK0jDldW/zYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_dialog_b_2.png
// module id = d8wJ
// module chunks = 0